import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getT } from '../utils/translations';
import { trackEvent } from '../utils/gtag';

export default function Navbar() {
  const { lang, setLang } = useLanguage();
  const t = getT(lang);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100 h-14 sm:h-16 flex items-center justify-end px-4 sm:px-6 lg:px-12">
      {/* Language Toggle */}
      <button
        onClick={() => { const newLang = lang === 'zh' ? 'en' : 'zh'; trackEvent('language_toggle', { language: newLang }); setLang(newLang); }}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors text-sm font-medium text-gray-700"
        title={lang === 'zh' ? 'Switch to English' : '切换中文'}
      >
        <span className="text-base leading-none">{lang === 'zh' ? '🌐' : '🌐'}</span>
        <span>{t.nav.langToggle}</span>
      </button>
    </nav>
  );
}
